var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { FormControlLabel, Radio, RadioGroup, styled, FormLabel, FormControl, FormHelperText } from '@mui/material';
var StyledFormControlLabel = styled(FormControlLabel)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .MuiFormControlLabel-label': {
            fontSize: '0.875rem',
            color: theme.palette.text.primary,
        },
    });
});
export function CustomRadioGroup(_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, options = _a.options, name = _a.name, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, helperText = _a.helperText, _e = _a.collumn, collumn = _e === void 0 ? false : _e, radioGroupProps = __rest(_a, ["label", "value", "onChange", "options", "name", "required", "error", "disabled", "helperText", "collumn"]);
    return (_jsxs(FormControl, __assign({ error: error, sx: { display: collumn ? 'flex' : '', } }, { children: [_jsx("div", __assign({ style: { display: 'flex', justifyContent: 'start' } }, { children: label && (_jsxs(FormLabel, { children: [label, required ? '*' : ''] })) })), _jsx(RadioGroup, __assign({ onChange: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e); }, style: { display: collumn ? '' : 'inline-block', justifyContent: 'start', marginLeft: collumn ? '8px' : '', marginTop: collumn ? '4px' : '' }, value: String(value) }, radioGroupProps, { name: name }, { children: options.map(function (opt, idx) { return (_jsx(StyledFormControlLabel, { value: String(opt.value), disabled: disabled, control: _jsx(Radio, {}), label: opt.label }, "".concat(name, "_opt_").concat(idx))); }) })), error && helperText && _jsx(FormHelperText, { children: helperText })] })));
}
